<template>
    <div>
        <b-sidebar aria-labelledby="sidebar-no-header-title" no-header id="add_paytype" backdrop style="direction:ltr" width="50rem" right :title="$parent.lang.add_pay_type" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" style="direction:rtl">
                    <div style="white-space:nowrap;width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                    <span>{{ pagetitle }}</span>
                    </div>
                    <div @click="hide" id="closeaddpayment" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm closethis">
                    <span>{{$parent.lang.close}}</span>
                </div>
                </div>
                <v-divider></v-divider>
                <v-row :style="`direction:`+$parent.lang.dir" class="pa-2 m-2">
                    <v-col cols="12" md="4" sm="12">
                        <label>{{$parent.lang.namear}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.namear"
                            v-model="type_name" 
                            :rules="fieldRules"
                        >{{ type_name }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{$parent.lang.nameen}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.nameen"
                            v-model="type_name_en" 
                            :rules="fieldRules"
                        >{{ type_name_en }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{$parent.lang.type}}</label>
                        <b-form-select class="selborder"
                            v-model="balanced_type"
                            :options="balancedTypes"
                        ></b-form-select>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" class="d-flex align-items-center">
                        <b-form-checkbox
                            v-model="is_cash"
                            :value="1"
                            :unchecked-value="0"
                        >{{$parent.lang.cash}}</b-form-checkbox>
                    </v-col>
                    <v-col cols="12" md="2" sm="12">
                        <label>{{$parent.lang.classid}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.classid"
                            v-model="classid" 
                            readonly
                            @change="checkClass()"
                        >{{ classid }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <label>{{$parent.lang.class_name}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.class_name"
                            v-model="class_name"
                            list="my-list-id"
                            @change="changeClassid(1)"
                        ></b-form-input>
                        <datalist id="my-list-id">
                            <option v-for="(item,index) in classes" :key="index">{{item.classid}} - {{ item.namear }}</option>
                        </datalist>
                        
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="balanced_type==2">
                        <label>{{$parent.lang.classid_balanced}}</label>
                        <b-form-input class="inborder"
                            v-model="classid_balanced" 
                            readonly
                            @change="checkClass()"
                        >{{ classid }}</b-form-input>
                    </v-col>
                    <v-col cols="12" md="4" sm="12" v-if="balanced_type==2">
                        <label>{{$parent.lang.class_name_balanced}}</label>
                        <b-form-input class="inborder"
                            :label="$parent.lang.class_name"
                            v-model="class_name_balanced"
                            list="my-list-id"
                            @change="changeClassid(2)"
                        ></b-form-input>
                        <datalist id="my-list-id">
                            <option v-for="(item,index) in classes" :key="index">{{item.classid}} - {{ item.namear }}</option>
                        </datalist>
                        
                    </v-col>
                </v-row>
            </template>
            <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                        <b-button type="button" @click="addPaytype();" variant="success" class="ma-2" style="width:100px;">{{ $parent.lang.save }}</b-button>
                    </div>
            </template>
        </b-sidebar>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default {
    data() {
        return {
            balanced_type: 1,
            type_name: '',
            type_name_en: '',
            classid: '',
            id: '',
            class_name: '',
            is_cash: 0,
            classid_balanced: "",
            class_name_balanced: "",
            classes: [],
            fieldRules: [],
            pagetitle: this.$parent.lang.add_pay_type
        }
    },
    created() {
        this.getClasses();
    },
    computed: {
        balancedTypes() {
            return [
                {text: this.$parent.lang.general_payment, value: 1},
                {text: this.$parent.lang.balanced_payments, value: 2}
            ];
        }
    },
    methods: {
        getClassname(classid, type){
            if(type == 1){
                this.classid = '';
                this.class_name = '';                
                for(let i =0; i < this.classes.length;i++){
                    if(this.classes[i].classid == classid){
                        this.class_name = this.classes[i].classid + ' - ' + this.classes[i].namear
                        this.classid = classid;
                    }
                }
            }
            else if(type == 2){
                this.classid_balanced = '';
                this.class_name_balanced = '';  
                for(let i =0; i < this.classes.length;i++){
                    if(this.classes[i].classid == classid){
                        this.class_name_balanced = this.classes[i].classid + ' - ' + this.classes[i].namear
                        this.classid_balanced = classid;
                    }
                }
            }
        },
        changeClassid(type){
            // for(let i =0; i < this.classes.length;i++){
            //     if(type == 1){
            //         if(this.classes[i].classid + ' - ' + this.classes[i].namear == this.class_name){
            //             this.classid = this.classes[i].classid
            //         }
            //     }else{
            //         if(this.classes[i].classid + ' - ' + this.classes[i].namear == this.class_name_balanced){
            //             this.classid_balanced = this.classes[i].classid
            //         }
            //     }
            // }
            if(type == 1){
                const clased = this.class_name.split(" - ");
                this.classid = clased[0];
            }else{
                const clased = this.class_name_balanced.split(" - ");
                this.classid_balanced = clased[0];
            }
         
        },
        getClasses(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getPostedCOA")
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[lang]",this.$parent.lang.langname);
    
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.classes = res.results.data;
            })
        },
        
        addPaytype(){
            let vald = true;
            let mess = '';
            if(this.type_name == ''){
                vald = false;
                mess = 'يرجى ادخال اسم طريقة الدفع بالعربي';
            }
            if(this.type_name_en == ''){
                vald = false;
                mess = 'يرجى ادخال اسم طريقة الدفع بالانجليزي';
            }
            if(this.balanced_type == 2 && (this.classid_balanced == '' || this.class_name_balanced == '')){
                vald = false;
                mess = 'حساب الموازنة مطلوب دائما';
            }else if(this.balanced_type == 1) {
                this.classid_balanced = '';
                this.class_name_balanced = '';
            }
            if(vald == false){
                this.$snotify.error(mess, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type',"doaddeditePT");
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki));
            post.append('data[type_name]',this.type_name);
            post.append('data[type_name_en]',this.type_name_en);
            post.append('data[classid]',this.classid);
            post.append('data[balanced_type]',this.balanced_type);
            post.append('data[is_cash]',this.is_cash);
            post.append('data[class_name_balanced]',this.class_name_balanced);
            post.append('data[classid_balanced]',this.classid_balanced);
            post.append('data[id]',this.id);
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                const res = response.data;
                // // console.log(res);
                if(typeof res.results.data !== 'undefined')
                {
                    let message = res.results.data;
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.$parent.lang.close, 
                                action: (toast) => {
                                    this.$snotify.remove(toast.id); 
                                } 
                            },
                        ]
                    });
                    this.$parent.getPyamentType();
                    document.getElementById('closeaddpayment').click();
                }
            })
        }
    },
}
</script>
